import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Solutionled(props) {
  return (
    <section className="solutionled p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Education App">
              <h2>
                Work with a Trusted Education Software Development Company
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              Building education software is more than just building a regular.
              The quality of education highly depends on the way your software
              facilitates the users- both teachers and students. For that
              purpose, you must collaborate with a professional education
              software development company with proven experience.
            </p>
            <p>
              Our education software developers are well-versed in building
              state-of-the-art LMS with built-in features like online quizzes,
              reporting, monitoring, evaluation, and self-assessment to enable
              users to keep track of their learning and development. Meanwhile,
              our education software development services use a UX-focused
              approach to ensure a clean and minimal user interface design with
              easy-to-navigate features. That’s how we ensure a remarkable
              learning experience to make education more fun and productive
              rather than a burden.
            </p>
            <div className="btn_talk">
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your App
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionled;
